import { ShieldTick } from "iconsax-react";
import { BsClock } from "react-icons/bs";
import styled from "styled-components";

import { Widget as WidgetStyled } from "@CheckoutStepsOffers/styles/Widget";

export const Container = styled.section`
  display: flex;
  flex-direction: column;

  width: 100%;
  padding: 1.5rem;

  border-radius: 0.5rem;
  background: ${({ theme }) => theme.checkoutStepsOffers?.cardBackground};

  @media (max-width: 375px) {
    padding: 0;
  }
`;

export const Strong = styled.strong`
  display: flex;
  align-items: center;

  margin: 0 0 0.5rem;

  font-family: Inter;
  font-size: 1rem;
  font-weight: 700;
  line-height: 1.5rem;

  color: ${({ theme }) => theme.checkoutStepsOffers?.textColor};
`;

export const Description = styled.p`
  margin: 0;

  font-family: Inter;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.25rem;

  color: ${({ theme }) => theme.checkoutStepsOffers?.widgetTextColor};
`;

export const Widget = styled(WidgetStyled)`
  min-height: 9.5rem;
`;

export const ClockIcon = styled(BsClock)`
  margin: 0 0.5rem 0 0;

  font-size: 1.25rem;
  color: ${({ theme }) => theme.checkoutStepsOffers?.textColor};
`;

export const ShieldIcon = styled(ShieldTick)`
  margin: 0 0.5rem 0 0;

  font-size: 1.25rem;
  color: ${({ theme }) => theme.checkoutStepsOffers?.textColor};
`;
